export default "__VITE_ASSET__329d32c9__"